module.exports = __webpack_public_path__ + "img/e794af6.jpg";